import { gql } from '@apollo/client'

export const Query = gql`
  query WarehouseLocationSelector($companyId: ID!, $id: ID) {
    warehouses(companyId: $companyId, filters: { idEq: $id }, first: 1) {
      nodes {
        id
        locations
      }
    }
  }
`
